import React from 'react';
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core';
import styled from 'styled-components';
import { Field, useField } from 'react-final-form';
import { IAlternative, IGridQuestion } from '../../../types';
import { showErrorOnChange } from '../../../utils/radioErrors';

interface IProps {
  question: IGridQuestion;
  alternatives: IAlternative[];
}

const GridQuestionRow = ({ question, alternatives }: IProps) => {
  const field = useField(`${question.id}`);
  const hasError = showErrorOnChange(field);
  const required = (value: string) => (value ? undefined : 'Required');
  return (
    <>
      <FormControl component={FullwidthContainer} error={hasError}>
        <RadioGroup row aria-label={question.title} name={`${question.id}`}>
          <Grid container spacing={0}>
            <StyledQuestionGrid item xs={4}>
              <QuestionTypography>{question.title}</QuestionTypography>

              {hasError && (
                <StyledFormHelperText>
                  {field.meta.error || field.meta.submitError}
                </StyledFormHelperText>
              )}
            </StyledQuestionGrid>
            <StyledItemGrid item xs={8}>
              <Grid justify="space-evenly" container>
                {alternatives.map((alternative) => {
                  return (
                    <StyledItemGrid
                      key={`radio-${question.title}-${alternative.text}`}
                      item
                      xs={2}
                    >
                      <StyledFormControlLabel
                        value={alternative.text}
                        label=""
                        control={
                          <Field
                            name={`${question.id}`}
                            type="radio"
                            initialValue=""
                            validate={required}
                          >
                            {({
                              input: {
                                name,
                                value,
                                onChange,
                                checked,
                                ...restInput
                              },
                            }) => {
                              return (
                                <Radio
                                  name={name}
                                  value={value}
                                  onChange={onChange}
                                  checked={checked}
                                  inputProps={{ ...restInput }}
                                />
                              );
                            }}
                          </Field>
                        }
                      />
                    </StyledItemGrid>
                  );
                })}
              </Grid>
            </StyledItemGrid>
          </Grid>
        </RadioGroup>
      </FormControl>
    </>
  );
};

const QuestionTypography = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-family: EB Garamond;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  width: 100%;
`;

const FullwidthContainer = styled.div`
  width: 100%;
`;

const StyledItemGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledQuestionGrid = styled(StyledItemGrid)`
  padding: 14px;
  display: flex;
  flex-direction: column;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 0;
`;

const StyledFormHelperText = styled(FormHelperText)`
  min-height: 25px;
`;

export default GridQuestionRow;
